/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["sbp",[["Lwamilawu","Pashamihe"],u,u],u,[["M","J","J","J","A","I","J"],["Mul","Jtt","Jnn","Jtn","Alh","Iju","Jmo"],["Mulungu","Jumatatu","Jumanne","Jumatano","Alahamisi","Ijumaa","Jumamosi"],["Mul","Jtt","Jnn","Jtn","Alh","Iju","Jmo"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Mup","Mwi","Msh","Mun","Mag","Muj","Msp","Mpg","Mye","Mok","Mus","Muh"],["Mupalangulwa","Mwitope","Mushende","Munyi","Mushende Magali","Mujimbi","Mushipepo","Mupuguto","Munyense","Mokhu","Musongandembwe","Muhaano"]],u,[["AK","PK"],u,["Ashanali uKilisito","Pamwandi ya Kilisto"]],1,[6,0],["dd/MM/y","d MMM y","d MMMM y","EEEE, d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","#,##0.00¤","#E0"],"TZS","TSh","Ihela ya Tansaniya",{"JPY":["JP¥","¥"],"TZS":["TSh"],"USD":["US$","$"]},"ltr", plural];
